import { first } from 'lodash';
import React from 'react';
import { MBView } from '@shared/components/MBView';
import { MBIconV2Name } from '@shared/components/image';
import { PressableTextRow } from '@shared/components/list';
import { RelatedCardComponent } from '@shared/scenes/workflows/config';
import { cursorPointerStyle } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { useGetCardName } from './hooks/DefaultRelatedCardRowHooks';

interface Props {
  component: RelatedCardComponent;
}

export function DefaultRelatedCardRow({ component }: Props) {
  const cardIds = component.default?.cardIds ?? [];
  const cardName = useGetCardName(first(cardIds));
  const cardText = getCardText(cardIds, cardName);

  return (
    <MBView style={cursorPointerStyle}>
      <PressableTextRow
        text={cardText}
        leftIcon={component.icon as MBIconV2Name}
        rightIcon="arrow-point-right"
        enabled={true}
        onPress={undefined}
      />
    </MBView>
  );
}

function getCardText(cardIds: string[], cardName: string) {
  const additionalRowText =
    cardIds?.length > 1 ? i18n('builder.defaultCard.rowText', { count: cardIds?.length - 1 }) : '';
  return cardName + additionalRowText;
}
